module.exports = __webpack_public_path__ + "05eda93efb15ea9efaf5bf2bc0feeb12.png";